import { Component, Vue } from 'nuxt-property-decorator';

@Component
export default class RouteContextMixin extends Vue {
  get isInUserDashboard(): boolean {
    return !this.$route.name || this.$route.name.startsWith('user-dashboard-');
  }

  get isInUserSubmissionsDashboard(): boolean {
    return !!this.$route.name && this.$route.name.startsWith('user-dashboard-participant-submissions');
  }

  get isInReviewerDashboard(): boolean {
    return !!this.$route.name && this.$route.name.startsWith('user-dashboard-reviewer');
  }

  get isInOrganizerDashboard(): boolean {
    return !!this.$route.name && this.$route.name.startsWith('organizations-id') && this.$route.params.id != null;
  }

  get isInEventDashboard(): boolean {
    return !!this.$route.name && this.$route.name.startsWith('events-') && this.$route.params.id != null;
  }
}
